export default __webpack_public_path__ + "static/media/a020-market-4.8dfd9a98.svg";